import configs from "./configs";

function hostnameFromDomain(domain) {
  try {
    return new URL(String(domain).includes("://") ? domain : `https://${domain}`).hostname.toLowerCase();
  } catch {
    return null;
  }
}

function originFromDomain(domain) {
  try {
    const url = new URL(String(domain).includes("://") ? domain : `https://${domain}`);
    return `${url.protocol}//${url.host}`;
  } catch {
    return null;
  }
}

function currentWindowOrigin() {
  return typeof window !== "undefined" ? window.location?.origin || null : null;
}

function appGateLinkUrl(metaverseDomain) {
  const origin = currentWindowOrigin() || originFromDomain(metaverseDomain);
  return origin ? `${origin.replace(/\/+$/, "")}/link` : "/link";
}

function isAppScopedShortlink(shortlinkDomain, metaverseDomain) {
  const shortlinkValue = String(shortlinkDomain || "").trim();
  if (!shortlinkValue) {
    return true;
  }

  const shortlinkHostname = hostnameFromDomain(shortlinkValue);
  if (!shortlinkHostname) {
    return false;
  }

  const metaverseHostname = hostnameFromDomain(metaverseDomain);
  const currentHostname = typeof window !== "undefined" ? window.location?.hostname?.toLowerCase() : null;

  return shortlinkHostname === metaverseHostname || shortlinkHostname === currentHostname;
}

function isPortalLabel(value) {
  return /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/.test(value);
}

function portalFromCurrentHost(hostname, metaverseDomain) {
  if (!hostname || !metaverseDomain) {
    return null;
  }

  const metaverseHostname = hostnameFromDomain(metaverseDomain);
  if (!metaverseHostname) {
    return null;
  }

  const currentHostname = hostname.toLowerCase();
  const suffix = `.${metaverseHostname}`;
  if (!currentHostname.endsWith(suffix)) {
    return null;
  }

  const portal = currentHostname.slice(0, -suffix.length);
  return isPortalLabel(portal) ? portal : null;
}

function portalShortlinkDomain(shortlinkDomain, portal) {
  try {
    const shortlinkUrl = new URL(
      String(shortlinkDomain).includes("://") ? shortlinkDomain : `https://${shortlinkDomain}`
    );
    const portalHost = `${portal}.${shortlinkUrl.hostname}`;
    return String(shortlinkDomain).includes("://") ? `${shortlinkUrl.protocol}//${portalHost}` : portalHost;
  } catch {
    return shortlinkDomain;
  }
}

export function getGateLinkUrl(shortlinkDomain = configs.SHORTLINK_DOMAIN, metaverseDomain = configs.RETICULUM_SERVER) {
  if (typeof window !== "undefined" && window.location?.hostname === "hubs.local") {
    return `${window.location.origin}/link`;
  }

  if (isAppScopedShortlink(shortlinkDomain, metaverseDomain)) {
    return appGateLinkUrl(metaverseDomain);
  }

  const portal = portalFromCurrentHost(
    typeof window !== "undefined" ? window.location?.hostname : null,
    metaverseDomain
  );
  if (portal) {
    return portalShortlinkDomain(shortlinkDomain, portal);
  }

  return shortlinkDomain;
}
